import React from 'react'
import isStoreOpenNow from '@helpers/websites/isStoreOpenNow'

import NextOpenDate from './NextOpenDate'

export default function NextOpenDateWrapper(props) {
  const {store} = props
  if (!store) return null

  const itsOpenNow = isStoreOpenNow(store)
  if (itsOpenNow) return null

  return <NextOpenDate {...props} />
}
